export const formatKobo = (kobo: number, opts: { sign?: boolean; symbol?: boolean } = {}) => {
  const { sign = false, symbol = true } = opts;
  const naira = Math.abs(kobo) / 100;
  const body = naira.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const prefix = kobo < 0 ? '-' : sign && kobo > 0 ? '+' : '';
  return `${prefix}${symbol ? '₦' : ''}${body}`;
};
